import { render, staticRenderFns } from "./TabHome.vue?vue&type=template&id=4f34deca&scoped=true&"
import script from "./TabHome.vue?vue&type=script&lang=js&"
export * from "./TabHome.vue?vue&type=script&lang=js&"
import style0 from "./TabHome.vue?vue&type=style&index=0&id=4f34deca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f34deca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VLayout})
